import React, { Component } from "react";
import { Switch, Route, Redirect } from "react-router-dom";
import { auth } from "./Firebase/firebase";
import { connect } from "react-redux";
import * as actionCreators from "./Store/actions/index";
// import './App.css';
import "aos/dist/aos.css";
import "./Styles/global.scss";
import LandingPage from "./Containers/LandingPage/LandingPage";
import Dashboard from "./Containers/LandingPage/Dashboard";
import Preview from "./Containers/Preview/Preview";
// import Authentication from './Containers/Authentication/Authentication';
import Register from "./Containers/Authentication/Register";
import EditPost from "./Containers/EditPost/EditPost";
import Activites from "./Containers/Activites/Activites";
// import Messages from "./Containers/Messages/Messages";
import Message from "./Containers/Messages/Message";
// import Chat from "./Containers/Chat/Chat";
import Chat2 from "./Containers/Chat/Chat2";
import BecomeFeature from "./Containers/BecomeFeature/BecomeFeature";
import TopUp from "./Containers/TopUp/TopUp";
import Profile from "./Containers/Profile/Profile";
import Services from "./Containers/Services/Services";
import Accessories from "./Containers/Accessories/Accessories";
import Rentals from "./Containers/Rentals/Rentals";
import Apparels from "./Containers/Apparels/Apparels";
// import RequiredForm from "./Containers/RequiredForm/RequiredForm";
import Required from "./Containers/RequiredForm/Required";
import Welcome from "./Components/Welcome/welcome";
import Layout from "./Hoc/Layout/Layout";
import Spinner from "./Components/UI/Spinner/Spinner";

class App extends Component {
  componentDidMount() {
    auth.onAuthStateChanged((user) => {
      if (user && user.emailVerified) {
        localStorage.setItem("user", user.email);
        this.props.onSuccessAuth(user);
        user.getIdTokenResult(true).then((res) => {
          // this.props.onGetWihsList(res.token)
          localStorage.setItem("idToken", res.token);

          this.refreshMyToken = setInterval(() => {
            localStorage.removeItem("idToken");
            user.getIdToken(true).then((newToken) => {
              localStorage.setItem("idToken", newToken);
              //console.log('new token to local', new Date().toTimeString())
            });
          }, 3590 * 1000);
          this.props.onGetCurrentLogeUser(res.token);
        });

        // if (isSpported()) {
        //   messaging.onTokenRefresh(() => {
        //     messaging.getToken().then((refreshedToken) => {
        //       localStorage.setItem('fcmToken', refreshedToken)
        //       let uid = localStorage.getItem('uid')
        //       database.ref(`recivers/${uid}`).set({ token: refreshedToken, id: uid })
        //         .then(res => console.log('sentToFIreDataBase', res))

        //     }).catch((err) => {
        //       console.log('Unable to retrieve refreshed token ', err);
        //     });
        //   });
        // }
      } else {
        localStorage.removeItem("idToken");
      }
    });
  }

  componentDidUpdate(prevProp) {
    if (this.props.hasInfo !== prevProp.hasInfo) {
      // console.log(this.props.hasInfo, prevProp.hasInfo)
      window.location.reload();
    }
  }

  componentWillUnmount() {
    clearInterval(this.refreshMyToken);
  }

  render() {
    let route = (
      <div style={{ width: "300px", margin: "0 auto" }}>
        <Spinner />
      </div>
    );
    if (this.props.userEmail) {
      if (this.props.currentUser) {
        if (!this.props.currentUser.name) {
          route = (
            <Switch>
              {/* < Route path='/requird' exact component={RequiredForm} /> */}
              <Route path="/requird" exact component={Required} />
              <Redirect to="/requird" />
            </Switch>
          );
        } else {
          route = (
            <Switch>
              <Route path="/Vehicles" exact component={LandingPage} />
              <Route path="/Dashboard" exact component={Dashboard} />
              <Route path="/Preview" exact component={Preview} />
              <Route path="/Edit" exact component={EditPost} />
              <Route path="/Activites" exact component={Activites} />
              {/* <Route path='/Messages' exact component={Messages} /> */}
              <Route path="/Messages" exact component={Message} />
              {/* <Route path='/Chat' exact component={Chat} /> */}
              <Route path="/Chat" exact component={Chat2} />
              <Route path="/Feature" exact component={BecomeFeature} />
              <Route path="/TopUp" exact component={TopUp} />
              <Route path="/Profile" exact component={Profile} />
              <Route path="/Services" exact component={Services} />
              <Route path="/Accessories" exact component={Accessories} />
              <Route path="/Rentals" exact component={Rentals} />
              <Route path="/Apparels" exact component={Apparels} />
              <Redirect to="/Dashboard" />
            </Switch>
          );
        }
      }
    } else {
      clearInterval(this.refreshMyToken);
      localStorage.removeItem("idToken");
      route = (
        <Switch>
          {/* <Route path='/Registration' exact component={Authentication} /> */}
          <Route path="/Register" exact component={Register} />
          <Route path="/" exact component={Welcome} />
          <Redirect to="/" />
        </Switch>
      );
    }
    return (
      <div className="MinAppHeight">
        <Layout
          userEmail={
            this.props.userEmail &&
            this.props.currentUser &&
            this.props.currentUser &&
            this.props.currentUser.ssm_number
          }
          onlogOut={this.props.onlogOut}
        >
          {route}
        </Layout>
      </div>
    );
  }
}

const mapStateToProps = (state) => {
  return {
    userEmail: state.Auth.userEmail,
    currentUser: state.Auth.currentUser,
    hasInfo: state.RequiredForm.hasInfo,
  };
};

const mapDispatchToProps = (dispatch) => {
  return {
    onSuccessAuth: (user) => {
      dispatch(actionCreators.successAuth(user));
    },
    onGetCurrentLogeUser: (token) => {
      dispatch(actionCreators.getCurrentLogedUserData(token));
    },
    // onGetWihsList: (token) => { dispatch(actionCreators.getWishList(token)) },
    onUserNotVerfiy: (message) => {
      dispatch(actionCreators.failAuth(message));
    },
    onlogOut: () => {
      dispatch(actionCreators.logoutAuth());
    },
  };
};

export default connect(mapStateToProps, mapDispatchToProps)(App);
